import { render, staticRenderFns } from "./ClientsList.vue?vue&type=template&id=77a67960&scoped=true&"
import script from "./ClientsList.vue?vue&type=script&lang=js&"
export * from "./ClientsList.vue?vue&type=script&lang=js&"
import style0 from "./ClientsList.vue?vue&type=style&index=0&id=77a67960&lang=scss&scoped=true&"
import style1 from "./ClientsList.vue?vue&type=style&index=1&id=77a67960&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a67960",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77a67960')) {
      api.createRecord('77a67960', component.options)
    } else {
      api.reload('77a67960', component.options)
    }
    module.hot.accept("./ClientsList.vue?vue&type=template&id=77a67960&scoped=true&", function () {
      api.rerender('77a67960', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory/supplier/ClientsList.vue"
export default component.exports